import { authenticationGuard } from 'fas-auth-poc';
import { Routes } from '@angular/router';
import { OskInvitationViewComponent } from './shared/components/osk-invitation-view/osk-invitation-view.component';
import { STATION_HANDOFF_ROUTE } from './components/students/internal-exam/station-handoff.storage';

export const routes: Routes = [
  { path: 'users', redirectTo: 'platform-users', pathMatch: 'full' },
  // The library's "Zgłoszenia / Opinie" page, replaced by one that shows the device and links to the account.
  { path: 'ratings', redirectTo: 'support-reports', pathMatch: 'full' },
  // The business card moved under the "Ustawienia OSK" tabs; keep old bookmarks working.
  { path: 'business-card', redirectTo: 'osk-settings/business-card', pathMatch: 'full' },
  // "Integracje" moved under "Ustawienia Platformy".
  { path: 'integrations', redirectTo: 'platform-settings/integrations', pathMatch: 'full' },
  {
    path: 'emailConfirmation',
    redirectTo: 'auth/emailConfirmation',
    pathMatch: 'full',
  },
  {
    // Where the panel lands, signed out, after "Ten komputer" in the exam dialog: the link into the
    // exam station to copy into another browser. Public on purpose - the OSK token is gone by then.
    path: STATION_HANDOFF_ROUTE,
    loadComponent: () =>
      import(
        './components/students/internal-exam/station-handoff-page/station-handoff-page.component'
      ).then((m) => m.StationHandoffPageComponent),
  },
  {
    path: '',
    loadChildren: () => import('fas-admin').then((m) => m.FASAdminModule),
    canActivate: [authenticationGuard()],
  },
  {
    path: 'osk-invitation',
    component: OskInvitationViewComponent
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('fas-auth-poc').then((m) => {
        m.FASAuthFlowModule.settings = {
          subMessageLogin: 'Zaloguj się do',
          messageLogin: 'Panelu',
          subMessageRegister: 'Zarejestruj się',
          messageRegister: 'Panelu',
          showNip: true,
          banerURL: 'assets/welcome-baner.png',
          logoURL: 'assets/brand/logo-poziome-ciemne-tlo.svg',
        };
        return m.FASAuthFlowModule;
      }),
  },
];



